"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOptionThatControlsPageCount = exports.PRODUCT_OPTIONS_THAT_CONTROL_PAGE_COUNT = exports.isSpreadBooksCategory = exports.isBooksCategory = exports.isABooksCategory = exports.isHammerCategoryType = exports.HAMMER_CATEGORY_FOLDED_CARDS = exports.HAMMER_CATEGORY_CARDS = exports.HAMMER_CATEGORY_CALENDARS = exports.HAMMER_CATEGORY_PRINTS = exports.HAMMER_CATEGORY_FRAMES = exports.HAMMER_SPREAD_BOOKS_CATEGORIES = exports.HAMMER_PAGE_BOOKS_CATEGORIES = exports.HAMMER_BOOKS_CATEGORIES = exports.HAMMER_CATEGORY_BOOKS = exports.HAMMER_CATEGORY_SIG_SPREAD_BOOKS = exports.HAMMER_CATEGORY_SPREAD_BOOKS = void 0;
exports.isProduct = isProduct;
const typeguard_1 = require("../types/typeguard");
const typeguard_2 = require("../types/typeguard");
exports.HAMMER_CATEGORY_SPREAD_BOOKS = 'spread books';
exports.HAMMER_CATEGORY_SIG_SPREAD_BOOKS = 'signature spread books';
exports.HAMMER_CATEGORY_BOOKS = 'books';
exports.HAMMER_BOOKS_CATEGORIES = [exports.HAMMER_CATEGORY_BOOKS, exports.HAMMER_CATEGORY_SPREAD_BOOKS, exports.HAMMER_CATEGORY_SIG_SPREAD_BOOKS];
exports.HAMMER_PAGE_BOOKS_CATEGORIES = [exports.HAMMER_CATEGORY_BOOKS];
exports.HAMMER_SPREAD_BOOKS_CATEGORIES = [exports.HAMMER_CATEGORY_SPREAD_BOOKS, exports.HAMMER_CATEGORY_SIG_SPREAD_BOOKS];
exports.HAMMER_CATEGORY_FRAMES = 'frames';
exports.HAMMER_CATEGORY_PRINTS = 'prints';
exports.HAMMER_CATEGORY_CALENDARS = 'calendars';
exports.HAMMER_CATEGORY_CARDS = 'cards';
exports.HAMMER_CATEGORY_FOLDED_CARDS = 'folded_cards';
const isHammerCategoryType = input => [exports.HAMMER_CATEGORY_SPREAD_BOOKS, exports.HAMMER_CATEGORY_SIG_SPREAD_BOOKS, exports.HAMMER_CATEGORY_BOOKS, exports.HAMMER_CATEGORY_FRAMES, exports.HAMMER_CATEGORY_PRINTS, exports.HAMMER_CATEGORY_CALENDARS, exports.HAMMER_CATEGORY_CARDS, exports.HAMMER_CATEGORY_FOLDED_CARDS].includes(input);
exports.isHammerCategoryType = isHammerCategoryType;
const isABooksCategory = hammerCategory => (hammerCategory || '').includes('books');
exports.isABooksCategory = isABooksCategory;
const isBooksCategory = hammerCategory => hammerCategory === exports.HAMMER_CATEGORY_BOOKS;
exports.isBooksCategory = isBooksCategory;
const isSpreadBooksCategory = hammerCategory => (hammerCategory || '').includes(exports.HAMMER_CATEGORY_SPREAD_BOOKS);
exports.isSpreadBooksCategory = isSpreadBooksCategory;
exports.PRODUCT_OPTIONS_THAT_CONTROL_PAGE_COUNT = ['pages', 'page_count', 'standard_page_count'];
const getOptionThatControlsPageCount = input => {
  if (!(0, typeguard_2.isTrueObject)(input)) {
    return undefined;
  }
  return Object.keys(input).filter(name => exports.PRODUCT_OPTIONS_THAT_CONTROL_PAGE_COUNT.includes(name)).shift();
};
exports.getOptionThatControlsPageCount = getOptionThatControlsPageCount;
const productRuleSet = {
  id: (0, typeguard_1.optional)(typeguard_1.isNumber),
  sku: typeguard_1.isNonEmptyString,
  name: (0, typeguard_1.optional)(typeguard_1.isNonEmptyString),
  hammerCategory: (0, typeguard_1.optional)(exports.isHammerCategoryType),
  editorVersion: (0, typeguard_1.optional)(typeguard_1.isNonEmptyString),
  qty: (0, typeguard_1.optional)(typeguard_1.isNumber),
  pageCount: (0, typeguard_1.optional)(typeguard_1.isNumber),
  price: (0, typeguard_1.optional)(typeguard_1.isNumber),
  productLine: (0, typeguard_1.optional)(typeguard_1.isString),
  productType: (0, typeguard_1.optional)(typeguard_1.isString),
  options: typeguard_1.isObject
};
function isProduct(p) {
  return (0, typeguard_1.isType)(p, productRuleSet);
}